<template>
  <v-container mx-0 px-0>
    <v-layout justify-center wrap>
      <v-flex xs12>
        <div class="headline my-1">Licenses</div>
      </v-flex>
      <v-flex xs12>
        <v-data-table
          :headers="headers"
          :loading="loading"
          :items="licenses"
          hide-actions
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.type }}</td>
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.expiration }}</td>
          </template>
        </v-data-table>
        <p style="position: absolute; bottom: 0; right: 16px; font-size: 12px; font-style:italic;">{{version}}</p>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import manips from '@/data/manips.js'
import { find } from 'lodash'
import LicensingService from '@/services/LicensingService'

export default {
  data: function () {
    return {
      headers: [
        {
          text: 'Type',
          align: 'left',
          sortable: false,
          value: 'type'
        },
        {
          text: 'Manipulatives',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        {
          text: 'Expiry',
          align: 'left',
          sortable: false,
          value: 'expiration'
        }
      ],
      licenses: [],
      loading: true
    }
  },
  components: {
  },
  computed: {
    version: function () {
      return 'v.' + process.env.VUE_APP_VERSION
    }
  },
  mounted: async function () {
    try {
      const result = await LicensingService.loadActiveLicenses();

      const arr = result.data;
      
      this.licenses = arr.map(license => {
        const expirationDate = new Date(license.expiration)
        const expirationString = expirationDate.toLocaleDateString()
        var name;
        var type = license.class ? 'Class' : 'Teacher';
        
        if (license.SchoolId !== null) {
          type = 'School';
        }

        if (license.scope === '*') {
          name = "All"
        } else {
          const info = find(manips, {'id': license.scope});
          name = info.displayName;
        }
        
        return {name: name, type: type, expiration: expirationString};
      })

      this.loading = false;
    } catch (err) {
      if (err.response.status === 403) {
        this.$router.push({
          path: '/logout'
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
